/**
 * System font stack fallback — mirrors legacy `src/theme/theme.ts` BASE_FONTS.
 * Do not change without coordinating with legacy theme.
 */
export const BASE_FONTS: readonly string[] = [
  '-apple-system',
  'BlinkMacSystemFont',
  "'Segoe UI'",
  'Oxygen',
  'Ubuntu',
  'Cantarell',
  "'Helvetica Neue'",
  'sans-serif',
];

export function buildFontFamilyStack(primaryFont: string): string {
  return [primaryFont, ...BASE_FONTS].join(',');
}
